import { render, staticRenderFns } from "./AddSingleDns.vue?vue&type=template&id=3766f56e"
import script from "./AddSingleDns.vue?vue&type=script&lang=js"
export * from "./AddSingleDns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports